<script>
  export default {
    name: 'MTableDataProcessors',
    data () {
      /**
       * preprocessors which get columns and render function and do something with columns. Used by mixins
       * @type {Array<ColumnPreprocessor>}
       */
      this.columnsPreprocessors = [];

      this.afterRowRenderedProcessors = [];

      return {};
    },
    methods: {

      /**
       * add {@param preprocessor} into {@link columnsPreprocessors}. Used by mixins
       * @param preprocessor {ColumnPreprocessor}
       */
      registerColumnsPreprocessor (preprocessor) {
        this.columnsPreprocessors.push(preprocessor);
      },

      registerAfterRowRenderedProcessor (p) {
        this.afterRowRenderedProcessors.push(p);
      },

      processAfterRowRendered (renderedRows, h, tableRow, rowIndex, isNestedTable) {
        let rows = renderedRows;
        this.afterRowRenderedProcessors.forEach(p => {
          rows = p(rows, h, tableRow, rowIndex, isNestedTable);
        });

        return rows;
      },

      callColumnProcessors (columns, h) {
        this.columnsPreprocessors.forEach(preprocess => {
          preprocess(columns, h);
        });
      }
    }
  };
</script>
